module.exports = "/dist//ionicons.svg?28df6ee7b407fd8a14b40bc01f4fd3ae";